import * as CL from '@design-system/component-library';
import { pictureStorageBaseUrl } from '../Picture/contentfulImageProxy';

const CTAButton = () => {
  const Variation = {
    FIVEG1000: '5g_1000',
  } as const;

  // Frosmo stuff gets loaded asynchronously, so we need to scroll to the element instead of using a ref
  const handleScroll = (variation: (typeof Variation)[keyof typeof Variation]) => {
    // analytics
    window.dataLayer?.push({
      event: 'cta_click',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      click_element_parent: `Yritysliittymät carousel - ${variation}`,
    });
    const element = document.querySelector(
      '.of-public-mobile-voice-subscriptions__subscriptions .of-subscription-cards'
    );
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      <CL.Button
        onClick={() => handleScroll(Variation.FIVEG1000)}
        size="s"
        className="of-public-mobile-voice-subscriptions-campaign__submit of-public-mobile-voice-subscriptions-campaign__submit--mobile"
      >
        Tutustu ja tilaa
      </CL.Button>
      <CL.Button
        onClick={() => handleScroll(Variation.FIVEG1000)}
        size="m"
        className="of-public-mobile-voice-subscriptions-campaign__submit of-public-mobile-voice-subscriptions-campaign__submit--desktop"
      >
        Tutustu ja tilaa
      </CL.Button>
    </>
  );
};

type CarouselItemProps = {
  imgSrc: string;
  heading: string;
  subheading?: string;
  description: React.ReactNode;
  mobileDescription?: React.ReactNode;
};

const CarouselItem = ({ imgSrc, heading, subheading, description, mobileDescription }: CarouselItemProps) => (
  <div className="of-public-mobile-voice-subscriptions-campaign__item">
    <img src={imgSrc} className="of-public-mobile-voice-subscriptions-campaign__image" alt="Campaign hero" />
    <div className="of-public-mobile-voice-subscriptions-campaign__content">
      <h3 className="of-public-mobile-voice-subscriptions-campaign__heading">{heading}</h3>
      {subheading && <h4 className="of-public-mobile-voice-subscriptions-campaign__subheading">{subheading}</h4>}
      <div className="of-public-mobile-voice-subscriptions-campaign__description of-public-mobile-voice-subscriptions-campaign__description--desktop">
        {description}
      </div>
      {mobileDescription && (
        <div className="of-public-mobile-voice-subscriptions-campaign__description of-public-mobile-voice-subscriptions-campaign__description--mobile">
          {mobileDescription}
        </div>
      )}
      <CTAButton />
    </div>
  </div>
);

export const PublicMobileVoiceSubscriptionsCampaign = () => {
  return (
    <section className="of-public-mobile-voice-subscriptions-campaign">
      <CL.Carousel
        buttons="primary"
        i18n_next_button_label="Seuraava"
        i18n_next_button_loop_label="Ensimmäinen"
        i18n_previous_button_label="Edellinen"
        i18n_previous_button_loop_label="Viimeinen"
        indicators
        loop
      >
        {[
          <CarouselItem
            imgSrc={`${pictureStorageBaseUrl}6CfXWkGkdJU27RfTMRKfc1/Sinisilmaisyyden-puolesta-mobiili-900x600.jpg?w=900`}
            heading="Sinisilmäisyyden puolesta"
            description={
              <ul>
                <li>Kotimaisilla Yritysliittymillä käytät veloituksetta mobiilivarmennetta.</li>
                <li>
                  Elisa Mobiilivarmenne yrityksille tarjoaa kätevän ja turvallisen tavan tunnistautua digitaalisissa
                  palveluissa.
                </li>
                <li>
                  Yritysliittymiin voi hankkia lisäpalveluna Mobiiliturvan. Palvelu tunnistaa ja varoittaa haitallisista
                  nettisivuista automaattisesti.
                </li>
              </ul>
            }
            mobileDescription={
              <ul>
                <li>Yritysliittymillä käytät veloituksetta mobiilivarmennetta.</li>
                <li>Voit hankkia lisäpalveluna Mobiiliturvan.</li>
              </ul>
            }
            key="1"
          />,
          <CarouselItem
            imgSrc={`${pictureStorageBaseUrl}uXzZavZdD2nIvHN57cIPE/_O6A2865.jpg?w=1920`}
            heading="Kotimainen liittymä aktiivikäyttäjälle: Premium 1000M"
            description={
              <ul>
                <li>
                  Liittymä sisältää Mobiiliturva -palvelun, mikä tunnistaa haitalliset sivustot ja tuo digiturvaa
                  käyttäessäsi mobiililiittymää
                </li>
                <li>Liittymällä käytät mobiilivarmennetta veloituksetta</li>
                <li>Lisäksi liittymässä monipuolinen Matkapuhelinvastaaja</li>
              </ul>
            }
            mobileDescription={
              <ul>
                <li>Liittymä sisältää Mobiiliturva -palvelun ja käytät mobiilivarmennetta veloituksetta</li>
              </ul>
            }
            key="2"
          />,
        ]}
      </CL.Carousel>
    </section>
  );
};
